 <template>
  <b-container fluid class="mt-4">
    <div v-if="loading" class="text-center">
      <b-spinner
        label="Loading..."
        variant="secondary"
        class="mx-center"
      ></b-spinner>
    </div>

    <div v-if="success">
      <b-row>
        <b-col>
          <label for="select-dimensions" class="bold"
            >Select main plot metric</label
          >
          <b-form-select
            v-model="metricLeft"
            :options="metrics"
            value-field="value"
            text-field="name"
            @change="updateChartData"
          ></b-form-select>
        </b-col>
        <b-col>
          <label for="select-dimensions" class="bold"
            >Select opposite plot metric</label
          >
          <b-form-select
            v-model="metricRight"
            :options="metrics"
            value-field="value"
            text-field="name"
            @change="updateChartData"
          ></b-form-select>
        </b-col>
      </b-row>
      <b-row class="my-3">
        <b-col>
          <apexchart
            height="350"
            type="line"
            :options="chartOptions"
            :series="seriesData"
          ></apexchart>
        </b-col>
      </b-row>
    </div>
  </b-container>
</template>

<script>
import util from "../util/util"
import defaults from "../util/defaults"

export default {
  name: "MetricsChart",
  props: [
    "context",
    "startDate",
    "endDate",
    "filtersQuery",
    "metrics",
    "plotMetrics",
  ],
  data() {
    return {
      chartOptions: {},
      loading: true,
      success: false,
      timeseriesData: { Date: [] },
      metricLeft: this.plotMetrics[0],
      metricRight: this.plotMetrics[1],
      seriesData: [
        {
          name: this.metricLeft,
          type: "column",
          data: [],
        },
        {
          name: this.metricRight,
          type: "line",
          data: [],
        },
      ],
      labelsData: [],
    };
  },
  methods: {
    updateChartData() {
      this.seriesData = [
        {
          name: this.metricLeft,
          type: "column",
          data: this.timeseriesData[this.metricLeft],
        },
        {
          name: this.metricRight,
          type: "line",
          data: this.timeseriesData[this.metricRight],
        },
      ];
      this.chartOptions = {
        chart: {
          type: "line",
        },
        stroke: {
          width: [0, 4],
        },
        dataLabels: {
          enabled: true,
          enabledOnSeries: [1],
        },
        xaxis: {
          categories: this.timeseriesData["Date"],
        },
        yaxis: [
          {
            title: {
              text: this.metricLeft,
            },
          },
          {
            opposite: true,
            title: {
              text: this.metricRight,
            },
          },
        ],
      };
    },
    async fetchData() {
      this.loading = true;
      this.success = false;
      try {
        let paramMap = defaults.getParamMap.call(this,[defaults.PARAMS.context,defaults.PARAMS.startDate,
          defaults.PARAMS.endDate, defaults.PARAMS.filterRaw, defaults.PARAMS.demoUid]);

        this.timeseriesData = await util.apiCall(process.env.VUE_APP_BASE_URL, defaults.ROUTES.ts, paramMap)
            .then((response) => response.json());

        this.updateChartData();

        this.success = true;
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/MetricsChart.vue